@if (visible) {
  <div class="modal_customer">
    @if (modal_otp) {
      <div class="modal_customer_body">
        <div class="modal_text_md text-center"> {{ viewText(otpTitleMsgEmail) }}</div>
        <br>
          @if (forFeedback && resetMainTimer === false) {
            <div class="modal_text_sm text-center">
              {{ otpFeedbackMsg1 }}<br>
              {{ otpFeedbackMsg2 }}<br>
              {{ otpFeedbackMsg3 }} ({{ formatEmail(email) }})<br>
              {{ otpFeedbackMsg4 }} @if (!showIntervalBlock && visible) {
              <span class="time">{{ formatTime(timeout, 0) }}</span>
              } {{ otpFeedbackMsg5 }}
            </div>
          }
          @if (forFeedback && resetMainTimer === true) {
            <div class="modal_text_sm text-center">
              {{ otpFeedbackMsg1 }}<br>
              {{ otpFeedbackMsg2 }}<br>
              {{ otpFeedbackMsg3 }} ({{ formatEmail(email) }})<br>
              {{ otpFeedbackMsg4 }} @if (!showIntervalBlock && visible) {
              <span class="time">{{ formatTimeResend(timeout, 0) }}</span>
              } {{ otpFeedbackMsg5 }}
            </div>
          }
          @if (!forFeedback && resetMainTimer === false) {
            <div class="modal_text_sm text-center">
              {{ otpNonFeedbackMsg0 }} <br>
              {{ otpNonFeedbackMsg1 }} <br>{{ otpNonFeedbackMsg2 }} ({{ formatEmail(email) }})
              <br>{{ otpNonFeedbackMsg3 }} @if (!showIntervalBlock && visible) {
                <span class="time">{{ formatTime(timeout, 0) }}</span>
                } @if (showIntervalBlock) {
                <span class="time">{{ tempTime }}</span>
                } {{ otpNonFeedbackMsg4 }}
              </div>
            }
            @if (!forFeedback && resetMainTimer === true) {
              <div class="modal_text_sm text-center">
                {{ otpNonFeedbackMsg0 }} <br>
                {{ otpNonFeedbackMsg1 }} <br>{{ otpNonFeedbackMsg2 }} ({{ formatEmail(email) }})
                <br>{{ otpNonFeedbackMsg3 }} @if (!showIntervalBlock && visible) {
                  <span class="time">{{ formatTimeResend(timeout, 0) }}</span>
                  } @if (showIntervalBlock) {
                  <span class="time">{{ tempTime }}</span>
                  } {{ otpNonFeedbackMsg4 }}
                </div>
              }
              <br>
                <form [formGroup]="form">
                  <input class="form-control"
                    type="text"
                    [ngClass]="{'input-error': failedAttempt && display_attempt_ctr != 0 && !isRenewedCall}"
                    formControlName="otp"
                    placeholder="Enter OTP"
                    maxlength="6">
                  </form>
                  <!--<div class="failed" *ngIf="display_resend_ctr > 0 && display_resend_ctr != max_resend_attempts">
                  {{ viewMsgs(otpFailedMsg1) }} {{ viewMsgs(display_resend_ctr) }} {{ viewMsgs(otpFailedMsg2) }}<br>
                  {{ viewMsgs(otpFailedMsg3) }}
                </div>-->
                @if (failedAttempt && display_attempt_ctr > 0 && !isRenewedCall ) {
                  <div class="failed">
                    {{ viewMsgs(otpFailedMsg1) }} {{ viewMsgs(display_attempt_ctr) }} {{ viewMsgs(otpFailedMsg2) }}<br>
                    {{ viewMsgs(otpFailedMsg3) }}
                  </div>
                }
                <br>
                  <button class="button button-active"
                    (click)="submit()"
                    style="width: 290px;"
                  [disabled]=" form.invalid || isLoading || showIntervalBlock">Verify</button>
                  <button class="button button-default"
                    style="width: 290px;"
                  (click)="confirmCancel()">Cancel</button>
                  <div class="resend-block">
                    <span>{{ otpNoCodeMsg }} </span><br>
                    <span class="resend-link" (click)="resendOTP()">Resend code</span>
                  </div>
                  @if (showIntervalBlock && ongoingIntervalBlock == 1) {
                    <div class="modal_text_sm text-center">
                      {{ otpIntervalMsg1 }} <span class="time"> {{ formatTimeInterval(intervalTimer, 0) }} </span> {{ otpIntervalMsg2 }}
                    </div>
                  }
                  @if (showIntervalBlock && ongoingIntervalBlock > 1) {
                    <div class="modal_text_sm text-center">
                      {{ otpIntervalMsg05 }} <span class="time"> {{ formatTimeInterval(intervalTimer, 0) }} </span> {{ otpIntervalMsg2 }}
                    </div>
                  }
                </div >
              }
              @if (modal_confirmCancel) {
                <div class="modal_customer_body">
                  <div class="modal_text_md text-center">Cancel verification</div>
                  <br>
                    <div class="modal_text_sm text-center">
                      {{ otpCancelMsg }}
                    </div>
                    <br>
                      <br>
                        <button class="button button-active"
                          style="width: 290px;"
                        (click)="cancel()">Proceed</button>
                        <button class="button button-default"
                          style="width: 290px;"
                        (click)="rejectCancel()">Cancel</button>
                        <br>
                        </div>
                      }
                    </div>
                  }
